import { memo } from 'react';
import { RedirectLoginTemplate } from 'components/templates/RedirectLoginTemplate';

type Props = {};

export const RedirectLoginPage = memo((_props: Props) => {
	return <RedirectLoginTemplate />;
});
